import type { GetServerSideProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'

// Components
import LegalIndex from '@/components/pages/HelpCenter/components/LegalIndex'
import HelpHead from '@/components/pages/HelpCenter/components/HelpHead'

// Libs
import { fetchHelpLegal } from '@/api/fetchHelpLegal'
import { countryQueryOf, getHelpCountry } from '@/components/pages/HelpCenter/methods'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'

// Types
import type { HelpLegalItem } from '@/api/fetchHelpLegal'

type Props = {
  docs: HelpLegalItem[]
  countryCode: string
  countryQuery: string | null
}

const HelpTerms = ({ pageProps }: { pageProps: Props }) => {
  const { docs, countryCode, countryQuery } = pageProps
  const { t } = useTranslation()

  return (
    <>
      <HelpHead title={t('Help_Center_Legal_Title')} description={t('Help_Center_Legal_Desc')} canonicalPath={ROUTE_PATH.HELP_TERMS} />
      <LegalIndex docs={docs} countryCode={countryCode} countryQuery={countryQuery ?? undefined} />
    </>
  )
}

export const getServerSideProps: GetServerSideProps<Props> = async ({ locale, query }) => {
  const countryCode = getHelpCountry(locale, query.country_code)
  // 清單只是補標題與更新日期；API 失敗時仍列出三份文件（各頁會用內建版本）
  let docs: HelpLegalItem[] = []
  try {
    docs = (await fetchHelpLegal({ countryCode }))?.list ?? []
  } catch (error) {
    console.error('[help/terms] fetch legal docs failed', error)
  }

  return {
    props: {
      docs,
      countryCode,
      countryQuery: countryQueryOf(query.country_code) ?? null,
      ...(await serverSideTranslations(locale as string, ['common'])),
    },
  }
}

export default HelpTerms
